// Chat glyphs: icons only this lane uses (docs/implement/lanes.md).
// Key = the icon's name, value = Lucide geometry, as in Icon.tsx.

export { chatGlyphs };

import type { AreaGlyphs } from "../Icon";

const SHIELD =
    "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z";

const chatGlyphs = {
    // A proposal (pen "Proposal" kicker).
    "git-pull-request-arrow": (
        <>
            <circle cx="5" cy="6" r="3" />
            <path d="M5 9v12" />
            <circle cx="19" cy="18" r="3" />
            <path d="m15 9-3-3 3-3" />
            <path d="M12 6h5a2 2 0 0 1 2 2v7" />
        </>
    ),
    // Partly backed by your sources.
    "shield-alert": (
        <>
            <path d={SHIELD} />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
        </>
    ),
    // Not backed by your sources.
    "shield-off": (
        <>
            <path d="m2 2 20 20" />
            <path d="M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71" />
            <path d="M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52-.01C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264" />
        </>
    ),
} satisfies AreaGlyphs;
